var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var geEntries = function (obj) {
    var ownProps = Object.keys(obj), i = ownProps.length, resArray = new Array(i); // preallocate the Array
    while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
};
var transform = function (prismicData) {
    if (!prismicData) {
        return prismicData;
    }
    var data = prismicData.data || prismicData;
    var result = {};
    var entries = geEntries(data);
    for (var i = 0; i < entries.length; i += 1) {
        var name_1 = entries[i][0];
        var value = entries[i][1];
        if (value &&
            value.length === 1 &&
            value[0].text !== undefined &&
            value[0].text !== null) {
            result[name_1] = value[0].text;
        }
        else if (value && value.length === 0) {
            result[name_1] = null;
        }
        else {
            result[name_1] = value;
        }
    }
    if (result.body) {
        result.body = result.body.map(function (slice) { return (__assign({ type: slice.slice_type }, transform(slice.primary), { items: slice.items.map(transform) })); });
    }
    return result;
};
export default transform;
//# sourceMappingURL=transform.js.map